import { stills } from "@/config/media";

// Responsive still: WebP with JPEG fallback, 800/1600 widths, lazy by default.
export default function MediaImage({ id, sizes = "100vw", className = "", eager = false, alt }) {
  const s = stills[id];
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${s.base}-800.webp 800w, ${s.base}-1600.webp 1600w`}
        sizes={sizes}
      />
      <img
        src={`${s.base}-1600.jpg`}
        srcSet={`${s.base}-800.jpg 800w, ${s.base}-1600.jpg 1600w`}
        sizes={sizes}
        alt={alt ?? s.alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        className={className}
      />
    </picture>
  );
}
